import axios from '@/services/request';
import {AxiosPromise} from "axios";
import store from "@/store";
import {SpuManage, TSku} from "@/model/Spu";
import {Resp, Page} from "@/model/Resp";
import ItemManage from "@/model/Item";
import {SpecManage, SpecSelect, specSpu} from "@/model/Spec";
import Task from "@/model/Task";

/**
 * item查询
 */
export function queryItemDetail(params: { itemId: number, taskId: number|undefined }, showLoading: boolean = false): AxiosPromise<Resp<ItemManage>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item/detail/similar/query`, params)
}

/**
 * item保存
 */
export function saveItemDetail(params: ItemManage, showLoading: boolean = false): AxiosPromise<Resp<ItemManage>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item/detail/similar/save`, params)
}


/**
 * 对齐规格信息
 */
export function checkSpecAlign(params: ItemManage, showLoading: boolean = false): AxiosPromise<Resp<SpecManage>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/spec/align/check`, params)
}

/**
 * 对齐用的标准spu下拉列表
 */
export function getSpecSelect(params: { baseSpuId: number }, showLoading: boolean = false): AxiosPromise<Resp<SpecSelect>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/spec/select`, params)
}

/**
 * 预览对齐信息
 */
export function previewSpecAlign(params: SpecManage, showLoading: boolean = false): AxiosPromise<Resp<specSpu[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/spec/sku/preview`, params)
}

/**
 * 保存对齐信息
 */
export function saveSpecAlign(params: SpecManage, showLoading: boolean = false): AxiosPromise<Resp<any>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/spec/align/save`, params)
}

/**
 * item关联spu查询
 */
export function recommendSpu(params: { itemId: number }, showLoading: boolean = false): AxiosPromise<Resp<SpuManage[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(` /api/item/recommend/similar/spus`, params)
}

/**
 * 获取spu的excel
 */
export function getItemExcel(params: { itemId: string }, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/out/download/perfect/anomaly/items`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 保存spu的excel
 */
export function saveItemExcel(params: FormData, showLoading: boolean = true): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/out/upload/perfect/anomaly/items`, params)
}

/**
 * 获取配置
 * @param params
 * @param showLoading
 */
export function getConfig(params: {
  type: 'region' | 'language' | 'toushou' | 'domain' | 'spu_attr'| 'task_status'
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/config/datas`, {params})
}

/**
 * 申请任务
 */
export function applyTask(params: {}, showLoading: boolean = true): AxiosPromise<Resp<any>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/taskSimilar/apply`, params)
}

/**
 * 任务列表
 */
export function getTaskList(params:  {
  taskKey?: string,
  userId?: number,
  startDate?: string,
  endDate?: string,
  status?: number,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = true): AxiosPromise<Resp<Page<Task>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/taskSimilar/mylist`, params)
}

/**
 * 暂存任务
 */
export function suspendTask(params: {id: number}, showLoading: boolean = true): AxiosPromise<Resp<any>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/taskSimilar/suspend`, params)
}

/**
 * 退回任务
 */
export function sendBackTask(params: {id: number}, showLoading: boolean = true): AxiosPromise<Resp<any>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/taskSimilar/sendback`, params)
}

/**
 * 操作日志
 */
export function getTaskLogList(params: {taskKey: number, taskType: number}, showLoading: boolean = false): AxiosPromise<Resp<Page<Task>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/taskSimilar/loglist`, params)
}

/**
 * 操作日志
 */
export function getTaskTodayCount(showLoading: boolean = false): AxiosPromise<Resp<{datas: {oldProduct: number, newProduct: number}[]}>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/taskSimilar/todaycount`)
}

/**
 * 获取task的excel
 */
export function getTaskExcel(params: {
  userId?: number,
  startDate?: string,
  endDate?: string,
  status?: number,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/taskSimilar/download`,
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}



